export const DASHBOARD_ROUTES = [
  { path: "/profile", tab: "overview" },
  { path: "/my-permissions", tab: "launcher" },
  { path: "/store", tab: "store" },
  { path: "/downloads", tab: "downloads" },
  { path: "/studio", tab: "studio", requiredTool: "raavaforge" },
  { path: "/playlist-transfer", tab: "playlist-transfer" },
  { path: "/security", tab: "security" },
  { path: "/announcements", tab: "changelog" },
  { path: "/support-tickets", tab: "tickets" },
  { path: "/community-chat", tab: "chat" },
  { path: "/permission-center", tab: "launcher", ownerOnly: true },
  { path: "/accounts", tab: "members", ownerOnly: true },
  { path: "/productkeys", tab: "licenses", ownerOnly: true },
  { path: "/release-manager/*", canonicalPath: "/release-manager", tab: "release-manager", ownerOnly: true },
  { path: "/chat-moderation", tab: "chat-moderation", ownerOnly: true },
  { path: "/discord-bots/configure", tab: "discord-bots-config", ownerOnly: true },
  { path: "/discord-bot", tab: "discord-bot", ownerOnly: true },
  { path: "/discord-community", tab: "discord-community", ownerOnly: true },
  { path: "/discord-tickets", tab: "discord-tickets", ownerOnly: true },
  { path: "/discord-security", tab: "discord-security", ownerOnly: true },
  { path: "/security-blacklist", tab: "security-blacklist", ownerOnly: true },
  { path: "/owner-credential", tab: "owner-key", ownerOnly: true },
  { path: "/audit-log", tab: "audit", ownerOnly: true },
  { path: "/system-status", tab: "system", ownerOnly: true },
];

export const DASHBOARD_LEGACY_ROUTES = [
  { path: "/dashboard", to: "/profile" },
  { path: "/support", to: "/support-tickets" },
  { path: "/community", to: "/community-chat" },
];

const DEFAULT_PATHS = Object.fromEntries(DASHBOARD_ROUTES.filter((route) => !route.ownerOnly).map((route) => [route.tab, route.canonicalPath || route.path]));
const OWNER_PATHS = Object.fromEntries(DASHBOARD_ROUTES.filter((route) => route.ownerOnly).map((route) => [route.tab, route.canonicalPath || route.path]));

export function dashboardPathForTab(tab, isOwner = false) {
  if (isOwner && OWNER_PATHS[tab]) return OWNER_PATHS[tab];
  return DEFAULT_PATHS[tab] || "/profile";
}
